/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import { useLocalization as m } from "@progress/kendo-react-intl";
import { clear as c, messages as u } from "../messages/index.mjs";
import { useUnstyled as p, classNames as d, uDateInput as f, IconWrap as g } from "@progress/kendo-react-common";
import { xIcon as x } from "@progress/kendo-svg-icons";
const y = (t) => {
  const s = m(), e = p(), l = e && e.uDateInput, r = s.toLanguageString(c, u[c]), i = (o) => {
    o.stopPropagation();
    const { onClick: n } = t;
    n && n.call(void 0, o);
  };
  return /* @__PURE__ */ a.createElement(
    "span",
    {
      className: d(f.clearButton({ c: l })),
      role: "button",
      onClick: i,
      tabIndex: t.tabindex || -1,
      title: r,
      key: "clearbutton"
    },
    /* @__PURE__ */ a.createElement(g, { name: "x", icon: x })
  );
};
export {
  y as default
};
